<div [ngClass]="getThemeClasses()">
  <h3 *ngIf="(filterField.name?.length || 0) > 0" class="page-title">{{ '' + filterField.name | translate }}</h3>
  <mat-tab-group (selectedTabChange)="changeTab($event)" [selectedIndex]="selectedIndex">
    <ng-container *ngIf="useCustomCase; else UpperCase">
      <mat-tab
        *ngFor="let tab of filterField.options"
        [label]="'' + (filterField.disableTranslation ? tab.name : (tab.name | translate))"
      />
    </ng-container>
    <ng-template #UpperCase>
      <mat-tab *ngFor="let tab of filterField.options" [label]="('' + tab.name).toUpperCase() | translate" />
    </ng-template>
  </mat-tab-group>
</div>
